export default __webpack_public_path__ + "static/media/Tractor.256.ec599d7d.png";